import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

export const StAccordion = styled(MuiAccordion)(({ theme }) => ({
  border: `1px solid #6f6f6f4f`,
  borderRadius: '0.75rem',
  boxShadow: 'none',
  marginBottom: '1rem',
  '&:before': {
    display: 'none',
  },
  color: `${theme.palette.black.main} !important`,
  '&:last-of-type': {
    borderBottomLeftRadius: '0.75rem',
    borderBottomRightRadius: '0.75rem',
  },
  '& .MuiButtonBase-root.MuiAccordionSummary-root': {
    paddingInline: '1.5rem',
  },
}));

export const StAccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.primary.main,
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
    color: theme.palette.primary.main,
  },
  '& .MuiAccordionSummary-content': {
    color: theme.palette.primary.main,
  },
}));

export const StAccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
  fontSize: '1rem',
  fontStyle: 'normal',
  lineHeight: '1.5rem',
  fontWeight: 400,
  '&.MuiAccordionDetails-root': {
    marginInline: '1.5rem',
    padding: 0,
  },
}));

export const StImageMediaContainer = styled('div')(({ theme }) => ({
  height: '382px',
  width: '686px',

  [theme.breakpoints.down('lg')]: {
    width: '100%',
    height: 'auto',
  },
}));

export const StVideoMediaContainer = styled('div')(({ theme }) => ({
  height: '382px',
  width: '686px',
  margin: '1rem 0',
  borderRadius: '8px',
  [theme.breakpoints.down('lg')]: {
    width: 'auto',
    height: '400px',
  },
  [theme.breakpoints.down(821)]: {
    width: 'auto',
    height: '420px',
  },
  [theme.breakpoints.down('md')]: {
    width: 'auto',
    height: '300px',
  },
  [theme.breakpoints.down(600)]: {
    width: 'auto',
    height: '280px',
  },
  [theme.breakpoints.down(550)]: {
    width: 'auto',
    height: '240px',
  },
  [theme.breakpoints.down(500)]: {
    width: 'auto',
    height: '220px',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'auto',
    height: '205px',
  },
  [theme.breakpoints.down(450)]: {
    width: 'auto',
    height: '210px',
  },
  [theme.breakpoints.down(415)]: {
    width: 'auto',
    height: '205px',
  },
}));
